export default "__VITE_ASSET__BJITlX$b__"